import { http, http4, http5, httpComposer } from "@/plugins/api";
import { TOKEN_REVISI } from "../stores/constants";

export const getAreasSap = () => {
  const url = "/area";

  return http4.get(url);
};

export const getAreasSapById = payload => {
  const url = `/cabang/${payload}`;

  return http4.get(url);
};

export const getProvincesSap = () => {
  const url = "/provinsi";

  return http4.get(url);
};

export const getProvincesSapById = citieId => {
  const url = `/kabupaten/${citieId}`;

  return http4.get(url);
};

export const getCitiesSap = ({ provinceId = "" }) => {
  const url = `/provinsi/${provinceId}/kabupaten`;

  return http4.get(url);
};

export const getCitiesSapById = districtId => {
  const url = `/kecamatan/${districtId}`;

  return http4.get(url);
};

export const getDistrictsSap = ({ cityId = "" }) => {
  const url = `/kabupaten/${cityId}/kecamatan`;

  return http4.get(url);
};

export const getDistrictsSapById = villageId => {
  const url = `/kelurahan/${villageId}`;

  return http4.get(url);
};

export const getVillagesSap = ({ districtId = "" }) => {
  const url = `/kecamatan/${districtId}/kelurahan`;

  return http4.get(url);
};

export const getBranchesByAreaIdSap = id => {
  const url = `/area/${id}/cabang`;
  return http4.get(url);
};

export const getBranchesByIdSap = id => {
  const url = `/area/branches/${id}`;
  return http4.get(url);
};

// export const getJenisAXI = () => {
//   const url = "/axi/tipe";

//   return http4.get(url);
// };

export const getJenisAXI = () => {
  const url = "/tipe_filter";

  return httpComposer.get(url);
};

export const getReligions = () => {
  const url = "/agama";
  return http4.get(url);
};

export const getStatus = () => {
  const url = "/axi/status";
  return http4.get(url);
};

export const getGenders = () => {
  const url = "/axi/jk";
  return http4.get(url);
};

export const getLegalForm = () => {
  const url = "/legalForm";
  return http4.get(url);
};

export const patchUpdateRevisi = ({ payload, profileId }) => {
  const url = `/axiReg/update/${profileId}`;
  const headers = {
    "Content-Type": "application/vnd.api+json",
    Authorization: `Bearer ${TOKEN_REVISI}`
  };

  let formData = new FormData();
  Object.keys(payload).forEach(function (key) {
    if (
      key != "foto_ktp" &&
      key != "foto_rekening" &&
      key != "foto_npwp"
      // && key != "foto_selfie"
    ) {
      if (payload[key] == null || payload[key] == "") {
        formData.set(key, "");
      } else {
        formData.set(key, payload[key]);
      }
    }
  });
  if (payload.foto_ktp && typeof payload.foto_ktp == "object")
    formData.set("foto_ktp", payload.foto_ktp);
  if (payload.foto_rekening && typeof payload.foto_rekening == "object")
    formData.set("foto_rekening", payload.foto_rekening);
  if (payload.foto_npwp && typeof payload.foto_npwp == "object")
    formData.set("foto_npwp", payload.foto_npwp);
  // if (payload.foto_selfie && typeof payload.foto_selfie == "object")
  //   formData.set("foto_selfie", payload.foto_selfie);

  return http5.post(url, formData, {
    headers
  });
};

export const getDecryptProfileId = profileId => {
  const url = `/axiReg/revisi`;
  const params = {
    kode: profileId
  };
  const headers = {
    "Content-Type": "application/vnd.api+json",
    Authorization: `Bearer ${TOKEN_REVISI}`
  };
  return http5.get(url, {
    headers,
    params
  });
};

export const getThirdPartySetting = axiId => {
  const url = `/thirdParty/setting`;
  const params = {
    axi_id: axiId
  };

  return http5.get(url, {
    params
  });
};

export const postThirdPartyValue = payload => {
  const url = `/thirdParty/value`;
  // const params = {
  //   profile_id: payload.profile_id
  // };

  return http5.post(url, payload, {
    // params
  });
};

export const getCheckEmail = payload => {
  const url = `/checkEmail/${payload.payloadEmail}`;
  const params = {
    profile_id: payload.profileId
  };

  return http5.get(url, {
    // params
  });
};

export const getCheckNoKtp = payload => {
  const url = `/checkNoKtp/${payload.noKtp}`;
  const params = {
    profile_id: payload.profileId
  };

  return http5.get(url, {
    // params
  });
};

export const getCheckNoHp = payload => {
  const url = `/checkNoHp/${payload.noHp}`;
  const params = {
    profile_id: payload.profileId
  };

  return http5.get(url, {
    // params
  });
};

export const getThirdPartyPageSetting = payload => {
  const url = `/bffnew/third_party/page_setting/list`;
  const params = {
    // pageNo: payload,
    // pageSize: payload,
    filter: payload.filter,
    filterValue: payload.filterValue
  };

  return http.get(url, {
    params
  });
};

export const getBranchByPostalCode = payload => {
  const url = `/transaction/params/getBranchByPostalCode?id=${payload.id}`;
  const headers = {
    Authorization: `Bearer ${payload.token}`
  };

  return http.post(url, {}, { headers });
};

export const getJenisKaryawan = () => {
  const url = "/jeniskaryawan";

  return http4.get(url);
};
